/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import '../../App.css';
import { MDBDataTable } from "mdbreact";
import { display } from '@mui/system';
import DataTable from "react-data-table-component";
import birthGif from '../../assets/gift.gif';
import anniversaryGif from '../../assets/wine.gif';
import Input from "../UI/Input/Input";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { Redirect, Switch, Route, Link } from "react-router-dom";

import { withRouter } from "react-router";
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';

import { Box, Button, Card, TextField } from '@mui/material';
import Pagination, { bootstrap5PaginationPreset } from 'react-responsive-pagination';
import { MonthPicker } from '@mui/lab';
// import { TextField } from '@material-ui/core';
import PendingIcon from '@mui/icons-material/Pending';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import { blue } from '@mui/material/colors';
import moment from 'moment';
class FreshsalesLeads extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    console.log(props)
    this.state = {
      items: [],
      custom_field: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: '',
      start_date: '',
      rest: '',
      end_date: '',
      type: '',
      currentPage: 1,
      totalPages: 1,
      total: '',
      per_page: 24,
      booking_status: '',
      booking_type: '',
      pax: [],
      file:null,
      message:''
    };
  }


  componentDidMount() {
    this.fetchData();
    this.fetchRestData();
    this.fetchOutletData();
  }


  fetchData() {
    let a = localStorage.getItem('user')
    let b = JSON.parse(a)
    let user_id = b.id
    let type = '2'
    let restro_id = b.restro_id
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    console.log('------------------', page)

    axios
      .post(endpoints.getFreshSalesData, {
        //  restro_id,type
        page,
        per_page

      })
      .then((response) => {
        // window.location.reload(true);
        console.log("response", response);
        this.setState({
          items: response.data.data.contacts,
          // custom_field: response.data.data.contacts.custom_field,

          // total: response.data.total,
          totalPages: response.data.data.meta.total_pages,
          DataisLoaded: true,
          // booking_status:response.data.data.booking_status
        });

        // console.log(response.data.data.contacts[custom_field])
        console.log(response.data.data.contacts[0].custom_field['cf_pax'])


      });

  }
  


  fetchRestData() {
    let a = localStorage.getItem('user')
    let b = JSON.parse(a)
    let user_id = b.id
    let restro_id = b.restro_id
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getRestaurentsDropDown, {


      })
      .then((response) => {
        // window.location.reload(true);
        console.log("response", response);
        this.setState({
          restaurent: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log(response.data);


      });
  }

  fetchOutletData() {
    let a = localStorage.getItem('user')
    let b = JSON.parse(a)
    let user_id = b.id
    let restro_id = b.restro_id
    console.log(restro_id)
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getOutlet, {

        restro_id, user_id
      })
      .then((response) => {
        // window.location.reload(true);
        console.log("response", response);
        this.setState({
          restaurent_outlet: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        console.log('outlet ', response.data);


      });
  }

  filterfetch(e) {

    console.log(e)

  }

  handleFileChange = (event) => {
    this.setState({ file: event.target.files[0] });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData();
    
    formData.append('file', this.state.file);
    console.log('-----', this.state.file)

     axios.post(endpoints.uploadExcel, formData).then((response) => {
      console.log(response)
      // setloading(false);
      
      if (response.data.statuscode == 3) {
        alert('Data Uploaded Successfully')
        // window.reload()
        window.location.reload(true);

          // toast.success(response.data.message);
       
      } else {
        alert('Data Not Uploaded. Please Try Again ')
// window.reload()
window.location.reload(true);

          // toast.error(response.data.message);
      }
  });
    // axios.post(endpoints.uploadExcel , { formData }).then((response) => {})
    //   .then((response) => response.json())
    //   .then((data) => {
    //     this.setState({ message: data.message });
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     this.setState({ message: 'An error occurred while uploading the file' });
    //   });
  };

  render() {
    


    const { DataisLoaded, items, total } = this.state;
    const a = this.state.items;
    // const fv = this.state.custom_field
    // console.log(this.state.items.custom_field)

    const b = this.state.total

    const links = (this.state.restaurent);
    const outlets = (this.state.restaurent_outlet);
    const user = localStorage.getItem('user')
    const user_data = JSON.parse(user)
    this.restro_id = user_data.restro_id
    // console.log(outlets)

    // const b = JSON.stringify(a)
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1)
    const date = JSON.stringify(dates.getDate())
    const year = JSON.stringify(dates.getFullYear())
    const recent_date = month + '-' + date


    console.log(a, "items")


    const ExpandedComponent = (suppData) => ({ data }) => {
      // const a = JSON.parse(data, null, 2)

      // const myArray = JSON.parse(data.custom_field);
      const myArray = data.custom_field;

      console.log(myArray, 'myArray')


      return (
        <>

          <div className='row px-5'>

            <div className="col-md-8">
              <mat-card >
                <table>
                  <tr>
                    <th className='w-50'>Name :</th>
                    <td>{data.first_name}</td>
                  </tr>
                  <tr>
                    <th>Email :</th>
                    <td>{myArray.cf_email}</td>
                  </tr>
                  <tr>
                    <th>Mobile : </th>
                    <td>{data.mobile_number}</td>
                  </tr>
                  <tr>
                    <th>Restaurent Name :</th>
                    <td>{myArray.cf_restaurant_name}</td>
                  </tr>
                  <tr>
                    <th> Person : </th>
                    <td>{myArray.cf_pax}</td>
                  </tr>


                </table>
              </mat-card>
            </div>

            <div className="col-md-4">
              <mat-card>
                <table>
                  <tr>
                    <th>Source :</th>
                    <td>{myArray.cf_soure}</td>
                  </tr>


                  <tr>
                    <th> Booking Type : </th>
                    <td>{myArray.cf_booking_type}</td>
                  </tr>
                  <tr>
                    <th> Reservation Date : </th>
                    <td>{moment(myArray.cf_reservation_date).format('YYYY-MM-DD')}</td>
                  </tr>
                  <tr>
                    <th> Reservation Time : </th>
                    <td>{myArray.cf_reservation_time}</td>
                  </tr>
                  <tr>
                    <th> Type : </th>
                    <td>{myArray.cf_type}</td>
                  </tr>

                  <tr>
                    <th>  Device Type : </th>
                    <td>{myArray.cf_device_type}</td>
                  </tr>
                </table>
              </mat-card>
            </div>
          </div>
          {suppData}{" "}
        </>
      );
    };
    
    const columns =  [
      {

        selector: (row) => row.first_name,
        cellExport: (row) => row.first_name,
        sortable: true
      },
    
      {

        selector: (row) => row.mobile_number,
        cellExport: (row) => row.mobile_number,
        sortable: true
      },
   
      {
        selector: (row) => row.custom_field && row.custom_field.cf_booking_date,
        cellExport: (row) => row.custom_field && row.custom_field.cf_booking_date,
        sortable: true
      },
      {

        selector: (row) => row.created_at,
        cellExport: (row) => row.created_at,
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_lead_source,
        cellExport: (row) => row.custom_field && row.custom_field.cf_lead_source,
        
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_booking_type,
        cellExport: (row) => row.custom_field && row.custom_field.cf_booking_type,
        omit:true,
        sortable: true
      }, {
        selector: (row) => row.custom_field && row.custom_field.cf_booking_time,
        cellExport: (row) => row.custom_field && row.custom_field.cf_booking_time,
        omit:true,
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_type,
        cellExport: (row) => row.custom_field && row.custom_field.cf_type,
        omit:true,
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_device_type,
        cellExport: (row) => row.custom_field && row.custom_field.cf_device_type,
        omit:true,
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_restaurant_name,
        cellExport: (row) => row.custom_field && row.custom_field.cf_restaurant_name,
        omit:true,
        sortable: true
      },
      {
        selector: (row) => row.custom_field && row.custom_field.cf_email,
        cellExport: (row) => row.custom_field && row.custom_field.cf_email,
        omit:true,
        sortable: true
      },
    ];

    const setCurrentPage = (id) => {
      console.log('page id : ------', id)
      this.state.currentPage = id;
      this.fetchData();
    }

    const onSubmit = async e => {
      this.filterfetch(e)
      // console.log(e)


    }
    const removeStatusHandler = async (id, e) => {
      console.log('status-295', e.target.value)
      const status = e.target.value
      var set = ''
      if (status === 'Confirmed') {
        set = 'Confirm'
      }
      if (status === 'Cancelled') {
        set = 'Cancel'
      }
      const confirmBox = window.confirm(
        "Do you want to " + set + " Booking?"
      )
      if (confirmBox === true) {
        await axios.post(endpoints.update_booking_status, { id, status }).then((response) => { });
        window.location.reload();
      }

    };

    const bFilter = async () => {
      // console.log(this.start_date);
      var end_date = this.end_date
      var start_date = this.start_date
      if (this.rest === undefined) {
        var rest = ''
      }
      else {
        var rest = this.rest
      }

      console.log('working_rest', rest)
      // var type = this.type
      // var booking_type = this.booking_type


      let a = localStorage.getItem('user')  
      let b = JSON.parse(a)
      let user_id = b.id
      let restro_id = b.restro_id
      var page = this.state.currentPage;
    var per_page = this.state.per_page;

      axios
        .post(endpoints.FreshsalesFilter, {
          start_date,
          end_date,
          rest,
          // type,
          user_id,
          restro_id,
          page,
          per_page
          // booking_type

        })
        .then((response) => {
          // window.location.reload(true);
          console.log("response", response);
          this.setState({
            items: response.data.data.contacts.contacts,
            // total: response.data.total,
            totalPages:(response.data).length,
            DataisLoaded: true,
          });
          console.log(response.data);
        });

    }
    const onStartChange = e => {
      this.start_date = e.target.value

    }
    const onEndChange = e => {
      this.end_date = e.target.value

    }

    const onTypeChange = e => {
      this.type = e.target.value

    }


    const onBookingTypeChange = e => {
      this.booking_type = e.target.value

    }

    const onRestChange = e => {
      this.rest = e.target.value

    }
    const c = [
      {
       
        created_at: "CREATED AT",
        email: "EMAIL",
        first_name: "NAME",
        mobile_number:'NUMBER',
        custom_field:{ 
          cf_booking_type: "BOOKING TYPE",
          cf_device_type: "DEVICE TYPE",
          cf_email: "EMAIL",
          cf_pax: "PERSONS",
          cf_booking_date: "RESERVATION DATE",
          cf_booking_time: "RESERVATION TIME",
          cf_restaurants_location: 'LOCATION',
          cf_restaurant_name: "RESTAURENT NAME",
          cf_lead_source: "SOURCE",
          cf_type: "TYPE",
          cf_unique_id: "UNIQUE ID"
        },
      cf_pax: "PERSON",
       

      }
    ];
    // const data = heading.concat(c);
    const data = c.concat(a);
    const tableData = {

      columns,
      data,
    };


    if (!DataisLoaded)
      return (
        <div>
          <h4> Pleses wait some time.... </h4>{" "}
        </div>
      );

    return (
      <>
       <h2>FreshSales Leads</h2>

     <Card className="px-3 py-3">
      {/* <h3>Excel File Upload</h3> */}
     <form className="ui form" onSubmit={this.handleSubmit}>
        <label>Select File</label>
        <input type="file" onChange={this.handleFileChange} />
        <Button  style={{ color: 'white' }} variant="contained" size="medium" className='w-25' type="submit">Upload</Button>
        <p>{this.state.message}</p>
      </form>
     </Card>
       
        
        <Card className="px-3 py-3">
          <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
            <div className='row'>

              <div className='col-md-3'>

                {/* <Input id="start_date" label="Start Date" type="date" name="start_date" place="Start Date" onChange={(e) => onStartChange(e)}
                        requiredInput="required"
                    /> */}
                <label>Reservation Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Reservation Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,

                  }}
                  onKeyDown={(e) => e.preventDefault()}
                // InputProps={{
                //   readOnly: true,
                //  }}
                />
              </div>
              {/* <div className='col-md-3'>

                <label>Created At Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="Created At Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,

                  }}
                  onKeyDown={(e) => e.preventDefault()}
                // InputProps={{
                //   readOnly: true,
                //  }}
                />

              </div> */}
              {this.restro_id === 0 ? <div className="col-md-3">
                <label>Restaurant</label>
                <select name="rest" required className="form-control" onChange={e => onRestChange(e)}>
                  <option value="">Select Restaurant</option>
                  {links.map((e, key) => {
                    return <option key={key} value={e.name}>{e.name}</option>;
                  })}


                </select>
              </div> : ''}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button className='w-50' onClick={() => bFilter()} style={{ color: 'white' }} variant="contained" size="medium">
                    Filter
                  </Button>
                </div></div></div>


          </form>
        </Card>
        <div className='row mt-5'>

          <DataTableExtensions
            {...tableData}
          >
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 75, 100, 125, 150]}
              expandableRows
              exportHeaders={true}
              expandableRowsComponent={ExpandedComponent()}
            />

          </DataTableExtensions>
          <Pagination
            {...bootstrap5PaginationPreset}
            current={this.state.currentPage}
            total={this.state.totalPages}
            onPageChange={(e) => setCurrentPage(e)}
          />

        </div>
      </>
    );
  }
}
export default withRouter(FreshsalesLeads);
